// Libraries
import { DateTime } from "luxon";

// Resources
import { getAppointmentsByPatientId } from "API/Resource/appointment";

export const getPatientFormInitialValues = (patient) => ({
  id: patient?.id,
  firstName: patient?.firstName || "",
  lastName: patient?.lastName || "",
  email: patient?.email || "",
  primaryPhone: patient?.primaryPhone || "",
  secondaryPhone: patient?.secondaryPhone || "",
  dob: patient?.dob ? DateTime.fromISO(patient.dob) : null,
  healthCardNumber: patient?.healthCardNumber || "",
  updatedAt: patient?.updatedAt ? DateTime.fromISO(patient.updatedAt) : null,
  address: patient?.address || "",
  city: patient?.city || "",
  postalCode: patient?.postalCode || "",
  province: patient?.province || "MB",
  registrationNumber: patient?.registrationNumber || "",
  notes: patient?.notes || "",
  userEmail: patient?.userEmail || "",
  healthCardProvince: patient?.healthCardProvince || "",
  preferredLanguage: patient?.preferredLanguage || "",
});

export const updatePatientSearchResults = ({
  patientList,
  updatedPatient,
  matchesCurrentSearch,
}) => {
  const patientIndex = patientList.findIndex(
    (patient) => patient.id === updatedPatient.id
  );

  if (patientIndex === -1) {
    return patientList;
  }

  const stillMatches = matchesCurrentSearch
    ? matchesCurrentSearch(updatedPatient)
    : true;

  if (!stillMatches) {
    return [
      ...patientList.slice(0, patientIndex),
      ...patientList.slice(patientIndex + 1),
    ];
  }

  return [
    ...patientList.slice(0, patientIndex),
    updatedPatient,
    ...patientList.slice(patientIndex + 1),
  ];
};

export const fetchAppointmentsByPatientId = async ({
  patientId,
  setAppointments,
  setLoading,
  errorSnackbar,
}) => {
  if (!patientId) {
    return;
  }

  setLoading(true);
  try {
    const result = await getAppointmentsByPatientId(patientId);
    setAppointments(result);
  } catch (error) {
    errorSnackbar();
    setAppointments([]);
  } finally {
    setLoading(false);
  }
};
